/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CodeLanguage = {
    Logo: 'logo',
    Python: 'python',
    Cpp: 'cpp'
} as const;
export type CodeLanguage = typeof CodeLanguage[keyof typeof CodeLanguage];


export function instanceOfCodeLanguage(value: any): boolean {
    for (const key in CodeLanguage) {
        if (Object.prototype.hasOwnProperty.call(CodeLanguage, key)) {
            if (CodeLanguage[key as keyof typeof CodeLanguage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CodeLanguageFromJSON(json: any): CodeLanguage {
    return CodeLanguageFromJSONTyped(json, false);
}

export function CodeLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeLanguage {
    return json as CodeLanguage;
}

export function CodeLanguageToJSON(value?: CodeLanguage | null): any {
    return value as any;
}

export function CodeLanguageToJSONTyped(value: any, ignoreDiscriminator: boolean): CodeLanguage {
    return value as CodeLanguage;
}

